<template>

  <div>


    <t-form-list sortable
                 :generalErrors="generalErrors"
                 :items="items" :fields="fields" hide-header :command="command" :user-auth="userAuth" :status="status"
                 :busy="false" :busy-form="false" :busy-list="!listIsLoaded" :path="pathOrdained"
                 :primary-key-column="primaryKeyColumn"  disable-default-buttons
                 :enable-change-order-up-down="enableChangeOrderUpDown"
                 disable-footer-length
                 @onChangeOrder="getOrdainedItems"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey" />


  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"

import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 't-form-list-ordained',
  data() {
    return {
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        typeTriggerActionId: "",
      },
      fields: [{keyRead: this.primaryKeyColumn, keyDelete: this.primaryKeyColumn}, {key: "name", label: "Status Apontamento"}],
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      typeTriggerList: [],
      labelList: [],
      technicalReportList: [],
      stockProductLocationList: [],
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    pathOrdained: {//Criado o nome com sufixo do componente para não conflitar com campo path já existente
      type: String,
      required: true,
    },
    foreignKeyColumnOrdained: {//Criado o nome com sufixo do componente para não conflitar com campo foreignKeyColumn já existente
      type: String,
      required: true,
    },
    primaryKeyColumn: {
      type: String,
      required: true,
    },
    foreignKey: {
      type: Number,
      required: true,
    },
    enableChangeOrderUpDown:Boolean,
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

    },

    mountedPrepare() {

      //Especifica campos vindo do componente externo
      this.path = this.pathOrdained
      this.foreignKeyColumn = this.foreignKeyColumnOrdained

      this.defaultForm()
      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getOrdainedItems()

    },

    mountedList() {
      this.listIsLoaded = true
    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async getOrdainedItems(){
      await http.list(this.pathOrdained + "/selectAll").then((list) => {
        this.items = list
        this.listIsLoaded = true

      }).catch(error => this.responseError(error))
    }
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
